import { HLink, HLocalStorage, HUtils, MyIcon, MyUI } from "@macashipo/mlib"
import classNames from "classnames"
import { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { MyModal, MyForm } from "src/core/components"
import { isNotEmpty } from "src/core/helpers/utils"
import { FlowUpdateAuthInfo } from "src/helpers/Flows/Auth"
import {
  categoryFields,
  detailFields,
} from "src/modules/app_sigo/constants/fields"
import { SGPaths } from "src/modules/app_sigo/constants/paths"
import { showAlert } from "src/modules/app_sigo/helpers/ui"
import { useForceUpdate } from "src/modules/app_sigo/hooks/useForceUpdate"
import styled from "styled-components"

const ElementNeedChk = {
  Security: "select-security",
  MessageForOwner: "message-for-owner",
}

const getTimeNearstGreater = (time: any, arrTime = [] as any) => {
  let timeNear = 0

  arrTime?.forEach(item => {
    if (time < item && (item < timeNear || !timeNear)) {
      timeNear = item
    }
  })
  return timeNear
}

const UITypes = {
  rental_documents: (data, config) => {
    const list = data?.[config?.fieldData] || []
    if (list && list?.length > 0) {
      return (
        <WrapDocuments className="wrap-list">
          {list.map((v, i) => {
            const icon = v?.Icon || v?.IconUrl || ""
            let isIconFont = false
            if (icon && icon?.startsWith("flaticon")) {
              isIconFont = true
            }
            return (
              <div className="one-document" key={`one-document-${i + 1}`}>
                {isIconFont ? (
                  <i className={icon} />
                ) : (
                  // <i className="flaticon-profile" />
                  <img src={v?.IconUrl} alt="" />
                )}
                <div className="name">{v?.Text}</div>
              </div>
            )
          })}
        </WrapDocuments>
      )
    }
  },
  my_trip: (data, config, { fnList, keyUI, forceUpdateUI }) => {
    const arrDayDisabled = []
    const configFormMyTrip: any = {
      defaultValues: {
        ...data,
        DateFromTo: [
          data?.[categoryFields.fFromDate],
          data?.[categoryFields.fToDate],
        ],
      },
      controls: [
        {
          label: "",
          fieldName: "DateFromTo",
          type: "input_date_from_to_detail",
          more: {
            morePropsDateFlatPickr: {
              calendarStartDay: 0,
              isShowPopup: true,
            },
            moreOptionsDateFlatPickr: {},
            configMergeText: {
              titleWhenMergeText: "Chọn ngày",
            },
            mappingField: {
              fFrom: categoryFields.fFromDate,
              fTo: categoryFields.fToDate,
            },
            configSelectTime: {
              titleTimeFrom: "Giờ nhận xe",
              titleTimeTo: "Giờ trả xe",
            },
            configSelectDate: {
              titleDatePicker: "Chọn ngày",
              descriptionPicker:
                "Chọn ngày để biết giá chính xác của lịch trình",
              placeholderTo: "Chọn ngày trả",
              placeholderFrom: "Chọn ngày nhận",
              breakCharacter: "-ngày ",
              labelFrom: "Ngày nhận",
              labelTo: "Ngày trả",
            },
            classNameGroup: "w-100 datefromto",
          },
        },
      ],
    }
    return (
      <WrapMyTrip>
        <MyForm
          key={keyUI}
          className="check-in-out-time"
          configForm={configFormMyTrip}
          fnList={
            {
              afterUpdateValueControl: opts => {
                const { fieldName, newValue } = opts
                let needReload = false
                let values = {
                  [fieldName]: newValue,
                }
                if (fieldName === "DateFromTo") {
                  return
                } else fnList.updateData(values, { needReloadUI: needReload })
              },
              afterUpdateMultiValues: obj => {
                if (
                  obj?.[categoryFields.fDeliveryAddress] !==
                  data?.[categoryFields.fDeliveryAddress]
                ) {
                  if (fnList?.updateMoreData) {
                    fnList.updateMoreData({
                      isAddressChanged: true,
                    })
                    setTimeout(() => {
                      if (fnList?.updateData) {
                        fnList.updateData(obj)
                      }
                    }, 100)
                  }
                }
              },
              afterCloseSelectTime: value => {
                let newData: any = JSON.parse(JSON.stringify(data))
                fnList.updateData(newData, {
                  needReloadUI: true,
                  notRequestUpdate: true,
                })
              },
              afterSaveSelectTime: value => {
                let [start, end] = value
                let newData: any = JSON.parse(JSON.stringify(data))

                if (start && end && end > start) {
                  newData["FromDate"] = start
                  newData["ToDate"] = end
                  newData["DateFromTo"] = value
                }

                let needFormatValue = false
                if (!start && !end) {
                  const { ToDate, FromDate } = data
                  start = FromDate
                  end = ToDate
                  needFormatValue = true
                }
                // Chỉ format khi chưa chọn thời gian trả và khi thời gian thuê > = thời gian trả
                if (!end || start >= end || !start) {
                  needFormatValue = true
                }
                if (needFormatValue) {
                  let _newToDate = start + 86400000
                  let _newFromDate = end - 86400000
                  let endHours = new Date(start).getHours()
                  let endMinute = new Date(start).getMinutes()
                  let startHours = new Date(end).getHours()
                  let startMinute = new Date(end).getMinutes()
                  if (start >= end && end && start) {
                    endHours = new Date(end).getHours()
                    endMinute = new Date(end).getMinutes()
                    _newToDate = new Date(
                      new Date(_newToDate).setHours(endHours, endMinute, 0, 0)
                    ).getTime()
                    const nearestGreater = getTimeNearstGreater(
                      start,
                      arrDayDisabled
                    )
                    if (nearestGreater && _newToDate > nearestGreater) {
                      const dateGreater = new Date(nearestGreater)
                      dateGreater.setDate(dateGreater.getDate() - 1)
                      dateGreater.setHours(23, 30, 0, 0)
                      _newToDate = dateGreater.getTime()
                    }
                    newData[categoryFields.fToDate] = _newToDate
                    newData[categoryFields.fFromDate] = start
                    newData["DateFromTo"] = [start, _newToDate]
                  }
                  if (!end && start) {
                    _newToDate = new Date(
                      new Date(_newToDate).setHours(endHours, endMinute, 0, 0)
                    ).getTime()
                    const nearestGreater = getTimeNearstGreater(
                      start,
                      arrDayDisabled
                    )
                    if (nearestGreater && _newToDate > nearestGreater) {
                      const dateGreater = new Date(nearestGreater)
                      dateGreater.setDate(dateGreater.getDate() - 1)
                      dateGreater.setHours(23, 30, 0, 0)
                      _newToDate = dateGreater.getTime()
                    }
                    newData[categoryFields.fToDate] = _newToDate
                    newData[categoryFields.fFromDate] = start
                    newData["DateFromTo"] = [start, _newToDate]
                  }
                  if (!start && end) {
                    _newFromDate = new Date(
                      new Date(_newFromDate).setHours(
                        startHours,
                        startMinute,
                        0,
                        0
                      )
                    ).getTime()
                    newData[categoryFields.fFromDate] = _newFromDate
                    newData[categoryFields.fToDate] = end
                    newData["DateFromTo"] = [_newFromDate, end]
                  }
                }
                fnList.updateData(newData, {
                  needReloadUI: true,
                })
              },
              updateDataToView: (value, { cbSuccess, cbError }) => {
                let [start, end] = value
                let newData: any = JSON.parse(JSON.stringify(data))
                if (!start || !end) {
                  return
                }
                newData["FromDate"] = start
                newData["ToDate"] = end
                newData["DateFromTo"] = value
                fnList.updateDataToView &&
                  fnList.updateDataToView(newData, { cbSuccess, cbError })
              },
            } as any
          }
          renderFooter={() => <></>}
        />
        {config?.canShowAddress && (
          <>
            <div className="label-control" style={{ marginBottom: 20 }}>
              Địa điểm giao xe
            </div>
            <MyUI
              type="sg_vehicle_delivery_adress"
              config={{ typeUI: "modal-map" }}
              data={data}
              fnList={{
                fnUpdateDelivery: obj => {
                  if (obj) {
                    let _newDeliveryInfo = obj[detailFields.fDeliveryInfo]
                    if (obj[detailFields.fDeliveryInfo]) {
                      let objUpdate = {}
                      if (_newDeliveryInfo.IsUserTakeSelected) {
                        objUpdate = {
                          [detailFields.fDeliveryAddress]: null,
                          [detailFields.fLatitude]: null,
                          [detailFields.fLongitude]: null,
                        }
                      } else {
                        objUpdate = {
                          [detailFields.fDeliveryAddress]:
                            _newDeliveryInfo.OwnerShipDeliveryAddress,
                          [detailFields.fLatitude]:
                            _newDeliveryInfo.OwnerShipLat,
                          [detailFields.fLongitude]:
                            _newDeliveryInfo.OwnerShipLng,
                        }
                      }
                      objUpdate[detailFields.fDeliveryInfo] =
                        obj[detailFields.fDeliveryInfo]
                      fnList?.updateData && fnList.updateData(objUpdate)
                    }
                  }
                },
              }}
            />
          </>
        )}
      </WrapMyTrip>
    )
  },
  message_for_owner: (data, config, { fnList, warningMsg }) => {
    let _warningMsg = warningMsg?.[config?.id]
    return (
      <MyUI
        type="sg_message_for_owner"
        data={data}
        msg={config?.moreData}
        fnList={fnList}
        msgWarning={_warningMsg}
      />
    )
  },
  content_with_modal: (data, config) => {
    const _data = data?.[config?.fieldData] || {}
    const fullDescription = _data?.Content || ""
    const onHandleLearnMore = () => {
      MyModal.showFromComponent(
        <div
          dangerouslySetInnerHTML={{
            __html: fullDescription,
          }}
        ></div>,
        {
          title: _data?.Title,
          modalClassName: "default modal-filter modal-scrollable-inside",
          onScrollContent: true,
        }
      )
    }
    return (
      <WrapPartWithModal>
        {_data?.Title && <div className="title mb-16px">{_data?.Title}</div>}
        {_data?.Description && (
          <div
            className={classNames(
              "description",
              fullDescription ? "pb-30px" : ""
            )}
            dangerouslySetInnerHTML={{ __html: _data?.Description }}
          ></div>
        )}
        {fullDescription && (
          <>
            {config?.showFull ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: fullDescription,
                }}
              ></div>
            ) : (
              <Button
                color="underline-black"
                className="btn-more"
                onClick={onHandleLearnMore}
              >
                Tìm hiểu thêm
              </Button>
            )}
          </>
        )}
      </WrapPartWithModal>
    )
  },
  select_security: (data, config, { fnList, warningMsg }) => {
    const list = data?.[config?.fieldData] || []
    let _warningMsg = warningMsg?.[config?.id]
    if (list && list?.length > 0) {
      return (
        <MyUI
          type="sg_select_secutity"
          data={list}
          fnList={fnList}
          msgWarning={_warningMsg}
          defaultValue={config?.moreData}
        />
      )
    }
  },
}
const MyUIBookingConfirm = props => {
  const { fnList, isAuthenticated, data, moreData, canShow } = props
  const canBooking = data?.[detailFields.fCanBooking]
  const [keyUI, forceUpdateUI] = useForceUpdate()
  const [warningMsg, setWarningMsg] = useState({} as any)
  const [loading, setLoading] = useState(false)
  const [showSuccessBooking, setShowSuccessBooking] = useState(false)
  const [afterBookingData, setAfterBookingData] = useState({} as any)

  useEffect(() => {
    forceUpdateUI()
  }, [data])

  const getDataFirstSettingByKey = key => {
    if (fnList?.getDataFirstSettingByKey) {
      const detail = fnList?.getDataFirstSettingByKey(
        "DefaultValues.websiteSetting.detail"
      )
      return HUtils.get(detail, key)
    }
    return
  }
  const getConfigLogin = () => {
    return {
      configHeaderTitle: "Đăng nhập hoặc đăng ký để đặt xe",
      classNameHeader: "custom-header-login",
      notFocus: true,
    }
  }
  const getPartsConfig = () => {
    return [
      {
        id: "my_trip",
        type: "my_trip",
        title: "Chuyến đi của bạn",
        classWrap: "my-trip mobile-mt-30px",
        moreData: moreData?.msg4Owner,
        canShow: true,
        canShowAddress: isAuthenticated,
      },
      {
        type: "rental_documents",
        fieldData: detailFields.fDocuments,
        title: "Giấy tờ thuê xe",
        description: `Bạn phải chuẩn bị [dataLength] loại giấy tờ cá nhân sau đây`,
        defaultDescription: "Bạn phải chuẩn bị giấy tờ cá nhân sau đây",
        classWrap: "devitem-line margin-top-large",
        canShow:
          isAuthenticated &&
          data?.[detailFields.fDocuments] &&
          data?.[detailFields.fDocuments]?.length >= 1
            ? true
            : false,
      },
      {
        id: "Security",
        type: "select_security",
        title: "Tài sản thế chấp",
        classWrap: "devitem-line margin-top-large",
        description:
          "Bạn có thể chọn thế chấp một trong [dataLength] loại tài sản sau đây",
        defaultDescription: "",
        fieldData: detailFields?.fSecurities,
        canShow:
          isAuthenticated &&
          data?.[detailFields.fSecurities] &&
          data?.[detailFields.fSecurities]?.length >= 1
            ? true
            : false,
        moreData: moreData?.security,
      },
      {
        type: "content_with_modal",
        title: "",
        classWrap: "devitem-line margin-top-large",
        description: "",
        fieldData: detailFields.fPaymentInstructionInfo,
        canShow:
          isAuthenticated && data?.[detailFields.fPaymentInstructionInfo]
            ? true
            : false,
      },
      {
        id: "MessageForOwner",
        type: "message_for_owner",
        title: "Nhắn tin cho chủ xe",
        description: `Hãy chia sẻ thêm về nhu cầu thuê xe của bạn cũng như mô tả sơ về chuyến đi của bạn cho chủ xe`,
        classWrap: "devitem-line margin-top-large",
        moreData: moreData?.msg4Owner,
        canShow: isAuthenticated,
      },
      {
        type: "content_with_modal",
        title: "",
        classWrap: "devitem-line margin-top-large",
        description: "",
        fieldData: detailFields.fCancelBookingPolicyInfo,
        canShow:
          isAuthenticated && data?.[detailFields.fCancelBookingPolicyInfo]
            ? true
            : false,
      },
      {
        type: "content_with_modal",
        title: "",
        classWrap: "devitem-line margin-top-large",
        description: "",
        fieldData: detailFields.fGeneralProvisionInfo,
        canShow:
          isAuthenticated && data?.[detailFields.fGeneralProvisionInfo]
            ? true
            : false,
        showFull: true,
      },
    ]
  }
  const getDescription = value => {
    let _des = value?.description || ""
    const matches = _des.match(/\[(.*?)\]/)
    if (matches && matches?.length > 0) {
      let _valueField = data?.[value?.fieldData]
      if (matches?.[1] === "dataLength") {
        _des = _des.replace(matches[0], _valueField?.length)
        if (_valueField?.length === 1) {
          _des = value?.defaultDescription
        }
      } else {
        _des = _des.replace(matches[0], _valueField)
      }
    }
    return _des
  }
  const getDisabledBookingBtn = () => {
    if (!canBooking) {
      return true
    }
    if (loading) {
      return true
    }
    return false
  }
  /** Other function */
  const handleCloseBookingConfirm = () => {
    fnList?.onCloseBookingConfirm && fnList?.onCloseBookingConfirm()
    // forceUpdate()
  }
  const handleBooking = () => {
    if (!canBooking) {
      return
    }
    if (fnList?.onBooking) {
      setLoading(true)
      fnList?.onBooking({
        getWarningMessage: msg => {
          if (msg && Object.keys(msg)?.length > 0) {
            setWarningMsg(msg)
            handleWhenHasWarningMsg(msg)
          }
        },
        cbSuccess: data => {
          setLoading(false)
          if (data) {
            const orderNumber = HUtils.get(data, detailFields.fOrderNumber)
            setAfterBookingData(data)
            if (orderNumber) {
              setShowSuccessBooking(true)
            }
            onScrollToElement("booking-success", { block: "start" })
          }
          // showAlert({
          //   component: (
          //     <MyUI
          //       type="alert"
          //       alertType="success"
          //       title="Đang chờ xác nhận"
          //       msg="Cảm ơn bạn đã cho Sigo cơ hội được phục vụ. Kết quả đặt xe sẽ được chủ xe phản hồi - Chỉ thanh toán khi chuyến đi ở trạng thái “Chờ đặt cọc”."
          //     />
          //   ),
          // })
          // HLink.openUrl(SGPaths.chuyendicuatoi, "_self")
        },
        cbError: error => {
          setLoading(false)
          showAlert({
            component: (
              <MyUI
                type="alert"
                alertType="warning"
                title="Đặt xe thất bại"
                msg={
                  <div className="text-center">
                    Rất tiếc bạn không thể đặt xe này!
                    <br />
                    {error?.msg}
                  </div>
                }
              />
            ),
            className: "modal-filter",
          })
        },
        hasWarningMsg: () => {
          setLoading(false)
        },
      })
    }
  }
  const handleWhenHasWarningMsg = warningMsg => {
    if (warningMsg && Object.keys(warningMsg)) {
      const elementKeys = Object.keys(ElementNeedChk)
      elementKeys.every(k => {
        if (warningMsg?.[k]) {
          onScrollToElement(ElementNeedChk[k])
          return false
        }
        return true
      })
    }
  }
  const onRemoveWarningMsgByField = field => {
    let _newWarning: any = {}
    if (warningMsg && Object.keys(warningMsg)) {
      const keys = Object.keys(warningMsg)
      keys.forEach(k => {
        if (k !== field) {
          _newWarning[k] = warningMsg[k]
        }
      })
    }
    setWarningMsg(_newWarning)
  }
  const onScrollToElement = (id, { block = "center" }: any = {}) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ block: block, behavior: "smooth" })
    }
  }

  /** Render */
  const renderLogin = () => {
    return (
      <WrapLogin key={keyUI} className="devitem-line wrap-login">
        <MyUI
          type="sg_login"
          afterLogin={() => {
            const data = HLocalStorage.getObj("Auth-Info", {})
            if (data?.name && data?.avatar_url) {
              FlowUpdateAuthInfo({
                name: data?.name,
                avatar: data?.avatar_url,
              })
            }
          }}
          actionType="login"
          field="MobilePhone"
          moreConfig={getConfigLogin()}
        />
      </WrapLogin>
    )
  }
  const renderParts = () => {
    const parts = getPartsConfig()
    return (
      <>
        {parts?.length > 0 &&
          parts.map((v, i) => {
            if (!isNotEmpty(v?.canShow) || v?.canShow) {
              let description = getDescription(v)
              return (
                <div
                  className={classNames(
                    "one-part",
                    v?.classWrap ? v?.classWrap : ""
                  )}
                  key={`part-${i}`}
                >
                  {v?.title && <div className="title mb-16px">{v?.title}</div>}
                  {description && (
                    <div className="description pb-30px">{description}</div>
                  )}
                  {UITypes?.[v.type]
                    ? UITypes[v.type](data, v, {
                        fnList: {
                          ...fnList,
                          onRemoveWarningMsgByField: onRemoveWarningMsgByField,
                        },
                        warningMsg: warningMsg,
                        keyUI: keyUI,
                        forceUpdateUI: forceUpdateUI,
                      })
                    : null}
                </div>
              )
            }
            return <></>
          })}
      </>
    )
  }
  const renderBooking = () => {
    const agreeTermMsg = getDataFirstSettingByKey("orderTerms") || ""
    return (
      <WrapBooking className="devitem-line ">
        {agreeTermMsg && isAuthenticated && (
          <div
            className="agree-msg"
            dangerouslySetInnerHTML={{ __html: agreeTermMsg }}
          ></div>
        )}
        <MyUI
          type="sg_button"
          onClick={handleBooking}
          color="primary-v2"
          disabled={getDisabledBookingBtn()}
          loading={loading}
          btnName="Đặt xe"
          loadingColor={"#fff"}
        />
      </WrapBooking>
    )
  }
  const renderPriceDetails = () => {
    return (
      <MyUI
        type="sg_price_details"
        data={data}
        fnList={fnList}
        isInConfirm={true}
      />
    )
  }
  const renderCarInfoAndPriceDetails = () => {
    const image = data?.[detailFields.fAvatarUrl] || ""
    const name = data?.[detailFields.fName]
    const address = data?.[detailFields.fAddress] || ""
    const plate = data?.[detailFields.fPlateNumber]
    const rating = data?.[detailFields.fRVRating]
    const servedCount = data?.[detailFields.fServedCount] || 0
    return (
      <RightCard className="wrap-car-info">
        <div className="wrap-info">
          <img src={image} alt="" className="car-img" />
          <div className="details">
            <div className="name">{name}</div>
            {address && <div className="address">{address}</div>}
            {/* {plate && <div className="plate">{plate}</div>} */}
            <div className="rating-n-count">
              {rating && (
                <span style={{ marginRight: 12 }}>
                  <i
                    className="flaticon-star mauden"
                    style={{ fontSize: 18 }}
                  ></i>
                  {rating}
                </span>
              )}
              {servedCount > 0 && (
                <span>
                  <i
                    className="flaticon-car-2 mauden"
                    style={{ fontSize: 18 }}
                  ></i>
                  {servedCount} chuyến đi
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="wrap-price devitem-line">
          <div className="title mb-16px">Chi tiết giá</div>
          {renderPriceDetails()}
        </div>
      </RightCard>
    )
  }
  const renderSurcharge = () => {
    const bookingInfoList = data?.[detailFields.fBookingInfoItems] || []
    if (bookingInfoList && bookingInfoList?.length > 0) {
      return (
        <WrapSurcharge>
          <div className="title mb-16px">Phụ phí có thể phát sinh</div>
          {bookingInfoList?.length > 0 &&
            bookingInfoList.map((v, i) => {
              return (
                <div
                  key={i}
                  className={classNames(
                    "divitem ttcuoi",
                    i === bookingInfoList.length - 1 ? "noneborder" : ""
                  )}
                >
                  <span className="item-title">
                    <b> {v?.TitleLeft}</b>
                    <b className="pull-right">{v?.TitleRight}</b>
                  </span>
                  <p className="item-content">{v?.Content}</p>
                  <div className="clearfix"></div>
                </div>
              )
            })}
        </WrapSurcharge>
      )
    }
    return <></>
  }
  const renderContent = () => {
    // const insuranceConfig = getDataFirstSettingByKey("insurance") || {}
    return (
      <WrapContent className="wrap-content">
        <div className="left">
          {/* <MyUI type="sg_insurance" data={insuranceConfig} /> */}
          {renderParts()}
          {!isAuthenticated && renderLogin()}
        </div>
        <div className="right">
          {renderCarInfoAndPriceDetails()}
          {renderSurcharge()}
        </div>
      </WrapContent>
    )
  }
  const renderBookingSuccess = () => {
    return (
      <WrapBookingSuccess
        className={classNames("container", !showSuccessBooking && "hide")}
      >
        <MyUI type="sg_booking_success" data={afterBookingData} />
      </WrapBookingSuccess>
    )
  }
  return (
    <MyUI type="sg_content_overlay" id="booking-confirm" canShow={canShow}>
      <div
        className={classNames("container", showSuccessBooking ? "hide" : "")}
      >
        <Header>
          <Button onClick={handleCloseBookingConfirm} color="back">
            <i className="flaticon-left-arrow" />
          </Button>
          <div className="title">Xác nhận đặt xe</div>
        </Header>
        {renderContent()}
        {isAuthenticated && renderBooking()}
      </div>
      {renderBookingSuccess()}
      <MyUI type="sg_footer" />
    </MyUI>
  )
  // return (
  //   <Wrap
  //     className={classNames(
  //       "wrap-booking-confirm overlay",
  //       canShow ? "show" : ""
  //     )}
  //     id="booking-confirm"
  //   >
  //     <div
  //       className={classNames("container", showSuccessBooking ? "hide" : "")}
  //     >
  //       <Header>
  //         <Button onClick={handleCloseBookingConfirm} color="back">
  //           <i className="flaticon-left-arrow" />
  //         </Button>
  //         <div className="title">Xác nhận đặt xe</div>
  //       </Header>
  //       {renderContent()}
  //       {isAuthenticated && renderBooking()}
  //     </div>
  //     {renderBookingSuccess()}
  //     <MyUI type="sg_footer" />
  //   </Wrap>
  // )
}
const WrapContent = styled.div`
  display: flex;
  margin: 25px 0;
  & .wrap-part {
    margin-top: 22px;
  }
  & .left {
    width: 60%;
    margin-right: 40px;
  }
  & .right {
    width: calc(40% - 40px);
  }
  & .title {
    font-weight: 600;
    font-size: 22px;
    color: var(--color-text-222222);
    &.mb-16px {
      margin-bottom: 16px;
    }
  }
  & .one-part {
    & .description {
      font-size: 16px;
      &.pb-30px {
        padding-bottom: 30px;
      }
    }
  }
  & .my-trip {
    & .title-mytrip {
      margin-bottom: 22px;
    }
  }
  & .devitem-line.margin-top-large {
    margin-top: 30px;
    &::before {
      margin-bottom: 30px;
    }
  }
  @media (max-width: 996px) {
    flex-direction: column-reverse;

    & .left {
      width: 100%;
      margin-right: 0;
    }
    & .right {
      width: 100%;
    }
    & .mobile-mt-30px {
      margin-top: 30px;
    }
  }
`
const Header = styled.div`
  display: flex;
  align-items: center;
  & .title {
    margin-left: 25px;
    color: var(--color-text-000);
    font-weight: 500;
    font-size: 30px;
    line-height: 49px;
  }

  & .btn-back {
    background-color: transparent;
    color: var(--color-text-000);
    box-shadow: none;
    font-size: 20px;
    padding: 0;
    height: fit-content;
    border: none;
    i {
      display: flex;
    }
  }
  & .btn-back:hover,
  & .btn-back:active,
  & .btn-back:focus {
    color: var(--color-text-000);
    box-shadow: none;
    background-color: transparent;
    border: none;
  }
`
const Wrap = styled.div`
  &.overlay {
    height: 100%;
    position: fixed;
    z-index: 1;
    top: 65px;
    background-color: #fff;
    overflow-x: hidden;
    transition: 0.7s;
    padding: 0;
    opacity: 1;
    left: -100%;
    width: 100%;
  }
  &.show {
    width: 100%;
    padding-top: 30px;
    opacity: 1;
    left: 0;
  }
  & .hide {
    display: none;
  }
  @media (max-width: 820px) {
    &.overlay {
      top: 53px;
    }
    &.show {
      padding-top: 15px;
    }
  }
`
const WrapSurcharge = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 25px;
  border: 1px solid var(--color-border-dfdfdf);
  border-radius: 20px;
  & .title {
    font-size: 18px;
  }
  & .divitem {
    border-bottom: 1px solid var(--color-border-dfdfdf);
    padding-bottom: 12px;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
  & .item-title {
    // line-height: 19.12px;
  }
  & .item-content {
    font-size: 14px;
    // line-height: 17px;
    padding-top: 7px;
  }
  // @media (max-width: 996px) {
  //   max-width: 420px;
  // }
`
const RightCard = styled.div`
  padding: 25px;
  box-shadow: 0px 3px 18px 5px #0000001a;
  border: 1px solid var(--color-border-dfdfdf);
  border-radius: 20px;
  & .wrap-info {
    display: flex;
    img {
      margin-right: 15px;
      object-fit: contain;
      border-radius: 10px;
      max-width: calc(50% - 20px);
      max-height: 100px;
    }
  }
  & .details {
    font-size: 14px;
    line-height: 20px;
    & .name {
      color: var(--mauden);
      font-size: 16px;
      font-weight: 700;
      line-height: 28px;
    }
    & .plate {
      font-weight: 600;
    }
  }
  & .rating-n-count {
    padding-top: 10px;
    & span {
      i {
        margin-right: 5px;
      }
    }
  }
  // @media (max-width: 996px) {
  //   max-width: 420px;
  // }
`
const WrapLogin = styled.div`
  padding-top: 25px;
  & .custom-header-login,
  & .header {
    border-bottom: none;
    padding: 25px 0 0 0;
    margin: 0;
    margin-top: -25px;
    & .title {
      text-align: left;
      padding-left: 30px;
    }
    & .only-title {
      padding-left: 0;
    }
  }
  & .custom-header-login {
    & .title {
      text-align: left;
      padding-left: 0px;
    }
  }
  & .body {
    padding-top: 5px;
  }
  & .welcome-text {
    display: none;
  }
`
const WrapBooking = styled.div`
  padding-bottom: 25px;
  max-width: 60%;
  & .agree-msg {
    padding-bottom: 30px;
    line-height: 24px;
    font-size: 14px;
    a {
      color: var(--mauden);
      font-weight: 600;
      text-decoration: underline;
    }
  }
  & .btn-primary-v2 {
    min-width: 300px;
    min-height: 43px;
    font-size: 18px;
  }
  @media (max-width: 996px) {
    max-width: 100%;
  }
  @media (max-width: 567px) {
    & .btn-primary-v2 {
      min-width: 100%;
    }
  }
`
const WrapDocuments = styled.div`
  &.wrap-list {
    display: grid;
    grid-template-columns: repeat(4, minmax(0px, 1fr));
    gap: 1rem;
    margin-right: 0px;
    margin-left: 0px;
  }
  & .one-document {
    border: 1px solid var(--color-border-d3d3d3);
    padding: 15px;
    border-radius: 10px;
    img {
      width: 40px;
      max-height: 40px;
      object-fit: cover;
      display: flex;
    }
    i {
      font-size: 40px;
      color: var(--color-text-000);
      display: flex;
    }
    & .name {
      padding-top: 15px;
      font-weight: 600;
      font-size: 16px;
      line-height: 21.86px;
      color: #404040;
    }
  }
  @media (max-width: 1499x) {
    &.wrap-list {
      grid-template-columns: repeat(3, minmax(0px, 1fr));
    }
  }
  @media (max-width: 1199x) {
    &.wrap-list {
      grid-template-columns: repeat(3, minmax(0px, 1fr));
    }
  }
  @media (max-width: 567px) {
    &.wrap-list {
      grid-template-columns: repeat(1, minmax(0px, 1fr));
      gap: 0.75rem;
    }
  }
`
const WrapPartWithModal = styled.div`
  & .btn-underline-black {
    font-weight: 600;
    font-size: 16px;
  }
  & .btn-underline-black,
  & .btn-underline-black:hover,
  & .btn-underline-black:active,
  & .btn-underline-black:focus {
    font-weight: 600;
    font-size: 16px;
  }
`
const WrapBookingSuccess = styled.div``
const WrapMyTrip = styled.div`
  & .datefromto {
    & .btn-time-select {
      flex-direction: column;
      border-bottom: none;
      & .item {
        padding: 0;
        margin-bottom: 28px;
        position: relative;
        width: 100%;
        & .title,
        & .time {
          font-size: 16px;
        }

        &:after {
          display: block;
          content: "Thay đổi";
          font-weight: 700;
          color: var(--den);
          text-decoration: underline;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          pointer-events: none;
        }
      }
    }
  }
  & .wrap-vehicle-delivery {
    padding-right: 0;
  }
`

export default MyUIBookingConfirm
